import { TenantActivationsScreen } from "@src/features/patriot-tools";

export default TenantActivationsScreen;
